import { vehicleConstants } from "./constants/vehicleConstants";

export const getVehicles = (data: any) => ({
  type: vehicleConstants.getVehicleRequest,
  payload: data,
});

export const getVehiclesParams = (data: any) => ({
  type: vehicleConstants.getVehicleParamsRequest,
  payload: data,
});

export const createVehicle = (data: any) => ({
  type: vehicleConstants.vehicleCreateRequest,
  payload: data,
});

export const deleteVehicle = (data: any) => ({
  type: vehicleConstants.vehicleDeleteRequest,
  payload: data,
});

export const toggleVehicle = (data: any) => ({
  type: vehicleConstants.vehicleToggleRequest,
  payload: data,
});

export const viewVehicle = (data: any) => ({
  type: vehicleConstants.vehicleViewRequest,
  payload: data,
});

export const uploadVehicleImage = (data: any) => ({
  type: vehicleConstants.vehicleUploadRequest,
  payload: data,
});

export const saveTripSheet = (data: any) => ({
  type: vehicleConstants.tripSheetSaveRequest,
  payload: data,
});

export const listTripSheets = (data: any) => ({
  type: vehicleConstants.tripSheetListRequest,
  payload: data,
});

export const viewTripSheet = (data: any) => ({
  type: vehicleConstants.tripSheetViewRequest,
  payload: data,
});

export const deleteTripSheet = (data: any) => ({
  type: vehicleConstants.tripSheetDeleteRequest,
  payload: data,
});

export const listTripSheetsByVehicle = (data: any) => ({
  type: vehicleConstants.tripSheetByVehicleRequest,
  payload: data,
});

export const listTripSheetsByBatch = (data: any) => ({
  type: vehicleConstants.tripSheetByBatchRequest,
  payload: data,
});

export const vehicleActions = {
  getVehicles,
  getVehiclesParams,
  createVehicle,
  deleteVehicle,
  toggleVehicle,
  viewVehicle,
  uploadVehicleImage,
  saveTripSheet,
  listTripSheets,
  viewTripSheet,
  deleteTripSheet,
  listTripSheetsByVehicle,
  listTripSheetsByBatch,
};
